import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FundingSource } from '../../models/adhoc-service.model';

export interface FundingSelectDialogData {
  fundingSources: FundingSource[];
  selectedBudgetTypeId: string;
  recommendedBudgetTypeId: string;
  isHpac: boolean;
}

@Component({
  selector: 'app-funding-select-dialog',
  templateUrl: './funding-select-dialog.component.html',
  styleUrls: ['./funding-select-dialog.component.scss']
})
export class FundingSelectDialogComponent {
  selectedBudgetTypeId: string;

  constructor(
    public dialogRef: MatDialogRef<FundingSelectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FundingSelectDialogData
  ) {
    this.selectedBudgetTypeId = data.selectedBudgetTypeId;
  }

  onSelect(): void {
    this.dialogRef.close(this.selectedBudgetTypeId);
  }

  onCancel(): void {
    this.dialogRef.close(undefined);
  }
}
